<form (ngSubmit)="addLocation()" [formGroup]="addLocationForm" class="dialog-root">
  <h2 mat-dialog-title>{{ "location.add_location" | transloco }}</h2>

  <mat-dialog-content class="column">
    <mat-form-field hideRequiredMarker="true">
      <mat-label>{{"location.label.external_id" | transloco}}</mat-label>
      <input formControlName="externalId" matInput type="text" />
    </mat-form-field>

    <mat-form-field hideRequiredMarker="true">
      <mat-label>{{"location.name" | transloco}}</mat-label>
      <input formControlName="name" matInput type="text" />
    </mat-form-field>

    <mat-form-field hideRequiredMarker="true">
      <mat-label>{{"form.label.street" | transloco}}</mat-label>
      <input formControlName="street" matInput type="text" />
    </mat-form-field>

    <div class="row-gap">
      <mat-form-field class="horizontal-constraint" hideRequiredMarker="true">
        <mat-label>{{ "form.label.zipCode" | transloco }}</mat-label>
        <input formControlName="zipCode" matInput type="text" />
      </mat-form-field>

      <mat-form-field class="flex" hideRequiredMarker="true">
        <mat-label>{{ "form.label.city" | transloco }}</mat-label>
        <input formControlName="city" matInput type="text" />
      </mat-form-field>
    </div>

    <mat-form-field hideRequiredMarker="true">
      <mat-label>{{ "form.label.email" | transloco }}</mat-label>
      <input formControlName="emailAddress" matInput type="text" />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button (click)="close()" mat-button type="button">{{ "button.cancel" | transloco }}</button>
    <button mat-flat-button type="submit">{{ "location.add_location" | transloco }}</button>
  </mat-dialog-actions>
</form>
